/* eslint-disable-next-line import/prefer-default-export */
export const STATUS_CODES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  NEUTRAL: 'neutral',
  PARTIAL: 'partial',
  PENDING: 'pending',
  INFO: 'info',
  NULL: 'null',
} as const;
